import styled from 'styled-components';

export const SkeletonNoLoginLayout = styled.div`
  height: 100%;
`;

export const SkeletonNoLoginHeaderLayout = styled.div`
  height: 3rem;

  owc-skeleton-loader {
    margin: 10px;
    height: 100%;
    width: calc(100% - 20px);
  }
`;

export const SkeletonNoLoginContentLayout = styled.div`
  height: calc(95vh - 3rem);

  owc-skeleton-loader {
    margin: 10px;
    height: 100%;
    width: calc(100% - 20px);
  }
`;
